<template>
  <div class="">
    <div class="page-contain">
      <div class="page-contain-tab">
        <div class="content-box">
          <div class="search-content">
              <div class="search-content-fields">
                  <el-form label-position="top">
                      <el-row :gutter="15">
                          <el-col :span="4">
                              <el-form-item label="部门">
                                  <el-select @change="searchData.medicalField = '';searchData.teamL4 = ''" clearable placeholder="请选择" v-model="searchData.departId">
                                    <el-option v-for="item in (isConfigurationData ? departsList : userInfo.loginDeparts)" :key="item.id" :value="item.id" :label="item.departName">
                                    </el-option>
                                  </el-select>
                              </el-form-item>
                          </el-col>
                          <el-col :span="4">
                              <el-form-item label="Franchise/DA">
                                  <el-select @change="searchData.teamL4 = ''" clearable placeholder="请选择" v-model="searchData.medicalField">
                                    <el-option v-for="item in (isConfigurationData ? medicalFieldList : getMedicalFieldArray(searchData.departId, true))" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                                    </el-option>
                                  </el-select>
                              </el-form-item>
                          </el-col>
                          <el-col :span="4">
                            <el-form-item label="团队">
                              <el-select clearable placeholder="请选择" v-model="searchData.teamL4">
                                <el-option v-for="item in (isConfigurationData ? teamList : getTeamArray(searchData.departId, searchData.medicalField, true))" :key="item.id" :value="item.id" :label="item.teamName">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :span="4">
                              <el-form-item label="自定义/标准">
                                  <el-select clearable placeholder="请选择" v-model="searchData.typeId">
                                      <el-option label="标准" value="0"></el-option>
                                      <el-option label="自定义" value="1"></el-option>
                                  </el-select>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="讲者级别">
                                <el-select filterable clearable placeholder="请选择（可搜索）" v-model="searchData.speakerLevel">
                                    <el-option v-for="item in speakerLevelNames" :key="item.speakerLevel" :value="item.speakerLevel" :label="item.speakerLevel">
                                    </el-option>
                                </el-select>
                                <el-button class="btn-search" type="primary" @click="handleSearch()">搜索</el-button>
                            </el-form-item>
                          </el-col>
                      </el-row>
                  </el-form>
              </div>
          </div>
          <div class="operate">
            <div>
              <el-button type="primary" @click="handlerExportExcelClick()" plain>批量导出</el-button>
              <el-button :disabled="!canBatchDelete" type="primary" @click="handleBatchDeleteClick()" plain>批量删除</el-button>
              <el-button type="primary" @click="handleAddNewClick()">添加讲者级别</el-button>
            </div>
          </div>
          <common-crud ref="crud"
            :addNewOrEditData="addNewOrEditData"
            :searchData="searchData"
            :crudApi="crudApi"
            :tableData.sync="speakerLevelData"
            :showEditFormTitle="false"
            :beforeSave="beforeSave"
            :afterSave="handleSpeakerLevelChange"
            :afterDelete="handleSpeakerLevelChange"
            :selectedDataArray.sync="selectedData"
            :otherValid="validUpload"
            addSuccessMessages="添加讲者级别成功"
            editSuccessMessages="编辑讲者级别成功"
            deleteSuccessMessages="删除讲者级别成功"
            deleteBatchSuccessMessages="批量删除讲者级别成功"
          >
            <template slot="result">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column type="index" :index="indexMethod" width="60" label="序号">
              </el-table-column>
              <el-table-column :formatter="formatBaseData" sortable prop="departId" label="部门">
              </el-table-column>
              <el-table-column :formatter="formatBaseData" sortable prop="medicalField" width="135">
                <template slot="header" slot-scope="scope">
                  <div style="display:inline-block">
                    <div>Franchise/DA</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column sortable prop="teamL4" label="团队">
              </el-table-column>
              <el-table-column :formatter="formatBaseData" sortable prop="typeId" label="标准/自定义" width="140">
              </el-table-column>
              <el-table-column sortable prop="speakerLevel" label="讲者级别">
              </el-table-column>
               <el-table-column sortable prop="modelScore" label="评分">
              </el-table-column>
              <el-table-column :formatter="formatDateTime2Date" sortable prop="updateTime" label="更新时间">
              </el-table-column>
              <el-table-column sortable prop="updateBy" label="操作人">
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="110">
                <template slot-scope="scope">
                  <div class="table-column-operate">
                    <el-button :disabled="scope.row.typeId == '0'" type="text" @click="handleEditClick(scope.row)">
                      编辑
                    </el-button>
                    <el-button :disabled="scope.row.typeId == '0'" type="text" @click="handleDeleteClick(scope.row)">
                      删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template slot="customTitle">讲者级别</template>
            <template slot="editForm">
                <el-row>
                  <el-col>
                    <el-form-item required label="部门" prop="departId">
                        <el-select @change="addNewOrEditData.medicalField = '';addNewOrEditData.teamL4 = ''" placeholder="请选择" v-model="addNewOrEditData.departId">
                            <el-option v-for="item in (isConfigurationData ? departsList : userInfo.loginDeparts)" :key="item.id" :value="item.id" :label="item.departName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item required label="Franchise/DA" prop="medicalField">
                        <el-select @change="addNewOrEditData.teamL4 = ''" placeholder="请选择" v-model="addNewOrEditData.medicalField">
                            <el-option v-for="item in (isConfigurationData ? medicalFieldList : getMedicalFieldArray(addNewOrEditData.departId, false))" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item required label="团队" prop="teamL4">
                      <el-select placeholder="请选择" v-model="addNewOrEditData.teamL4">
                        <el-option v-for="item in (isConfigurationData ? teamList : getTeamArray(addNewOrEditData.departId, addNewOrEditData.medicalField, false))" :key="item.id" :value="item.id" :label="item.teamName">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item required label="讲者级别" prop="speakerLevel">
                      <el-input v-model="addNewOrEditData.speakerLevel" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item required label="评分（10分制）" prop="modelScore">
                      <el-select placeholder="请选择" v-model="addNewOrEditData.modelScore">
                          <el-option v-for="n in 10" :key="n" :label="n" :value="n"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                      <common-score
                          :disabledDownload="!canDownload"
                          ref="speakerMeetingType"
                          title="会议类型与讲者级别"
                          type="speakerMeetingType"
                          fileName="会议类型与讲者级别.xlsx"
                          :getExportParams="getScoreExportParams"
                          tipCode="15"
                      >
                      </common-score>
                  </el-col>
                </el-row>
            </template>
            <template slot="confirmAddNewMessage">
              <div>
                <span>确认添加讲者级别？</span>
              </div>
            </template>
            <template slot="confirmEditMessage">
              <div>
                <span>确认保存讲者级别？</span>
              </div>
            </template>
            <template slot="confirmDeleteMessage">
              <div>
                <span>删除讲者级别？</span>
              </div>
            </template>
            <template slot="confirmBatchDeleteMessage">
              <div>
                <span>批量删除讲者级别？</span>
              </div>
            </template>
          </common-crud>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import speakerlevelApi from '@/api/bizmanagement/speakerlevel';
import { mapGetters, mapActions } from 'vuex';
import * as orgUtil from '@/util/organizationUtil'
import bizmanagement from '@/api/bizmanagement/index';

export default {
  data() {
    return {
      isConfigurationData:true,
      departsList :[],
      medicalFieldList :[],
      teamList :[],
      speakerLevelData: [],
      searchData: {
        departId: '',
        medicalField: '',
        teamL4: '',
        departName: '',
        speakerLevel:''
      },
      addNewOrEditData: {
        departId: '',
        medicalField: '',
        teamL4: '',
        speakerLevel: '',
        modelScore: '',
      },
      crudApi: speakerlevelApi,
      selectedData: [],
      isEdit: false,
    }
  },
  computed: {
    ...mapGetters(['baseDataRecords','basedataGetName','basedataGetNameByRowIdField','userInfo']),
    canDownload() {
      return this.addNewOrEditData.departId && this.addNewOrEditData.medicalField && this.addNewOrEditData.speakerLevel;
    },
    canBatchDelete() {
      if(this.selectedData.length <= 0) {
        return false;
      }

      for (let index = 0; index < this.selectedData.length; index++) {
        const element = this.selectedData[index];
        if(element.typeId == "0") {
          return false;
        }
      }

      return true;
    },
    speakerLevelNames() {
      return _.uniqBy(this.baseDataRecords.SpeakerLevel, 'speakerLevel');
    }
  },
  methods: {
    ...mapActions(['reloadBaseDataByType','initBaseDataByTypes']),
    getMedicalFieldArray(departId, independ) {
      return orgUtil.franchiseArray(departId, independ);
    },
    getTeamArray(departId, medicalField, independ) {
      return orgUtil.teamArray(departId, medicalField, independ);
    },
    formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData(row, column, cellValue, index) {
      if((column.property == 'departId' || column.property == 'medicalField')
      ) {
        return row[column.property]?row[column.property]:'全部';
      }

      switch(column.property){
        case 'typeId':
          return row.typeId == '1'? '自定义' : '标准';
      }
      return row;
    },
    indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch() {
      this.$refs['crud'].handleSearch(1);
    },
    handleAddNewClick() {
      if(this.$refs.speakerMeetingType) {
        this.$refs.speakerMeetingType.clearFile();
      }
      this.$refs['crud'].handleAddNew();
      this.isEdit = false;
    },
    handleEditClick(item) {
      if(this.$refs.speakerMeetingType) {
        this.$refs.speakerMeetingType.clearFile();
      }
      this.$refs['crud'].handleEdit(item);
      this.isEdit = true;
    },
    beforeSave(saveData) {
      saveData.departName = this.basedataGetName('Depart', saveData.departId);
      saveData.medicalFieldName = this.basedataGetName('MedicalField', saveData.medicalField);
      saveData.file = this.$refs.speakerMeetingType.getFile()?this.$refs.speakerMeetingType.getFile().raw:null;
    },
    validUpload() {
      return this.$refs.speakerMeetingType.valid()
    },
    handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('讲者级别管理.xlsx');
    },
    handleSpeakerLevelChange() {
      this.reloadBaseDataByType('SpeakerLevel');
    },
    getScoreExportParams() {
      let params = _.clone(this.addNewOrEditData);
      params.flag = this.isEdit?2:1;
      params.departName = this.basedataGetName('Depart', params.departId);
      params.medicalFieldName = this.basedataGetName('MedicalField', params.medicalField);
      params.speakerLevelName = params.speakerLevel;
      if(params.id) {
        params.speakerLevelId = params.id;
      }

      return params;
    },
    getCustomizationArray(arr){
      if(arr.length > 0){
        const customizationArray = arr.map(ele => {
          const data = {
            id: ele,
            teamName: ele,
          }
          return data
        });
        return customizationArray
      }else return []
    }
  },
  mounted() {
    bizmanagement.queryBusDataOrg().then((res) => {
      this.isConfigurationData = res.isConfigurationData
        this.departsList = this.getCustomizationArray(res.departList)
        this.medicalFieldList = this.getCustomizationArray(res.medicalFieldList)
        this.teamList = this.getCustomizationArray(res.teamList)
        this.initBaseDataByTypes(['Depart','MedicalField','SpeakerLevel'])
        .then(() => {
          this.handleSearch();
        })
    })
   
  }
};
</script>

<style lang="less" scoped>
  .search-content {
    display: flex;
    margin-bottom: 22px;

    .search-content-fields {
      // width: 800px;

      .btn-search {
        margin-left: 10px;
      }
    }
  }
  .operate {
    float: right;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?7044c86d